import { Helmet } from "react-helmet-async";
import { SITE } from "@/data/site";

const ORG_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": "https://empirealu.uk/#business",
  name: SITE.name,
  alternateName: "Empire Alu",
  image: SITE.logo,
  logo: SITE.logo,
  telephone: SITE.phone,
  email: SITE.email,
  url: "https://empirealu.uk",
  address: {
    "@type": "PostalAddress",
    streetAddress: `${SITE.address.line1}, ${SITE.address.line2}`,
    addressLocality: SITE.address.town,
    postalCode: SITE.address.postcode,
    addressCountry: "GB",
  },
  geo: { "@type": "GeoCoordinates", latitude: 51.6013, longitude: 0.1616 },
  openingHours: "Mo-Fr 09:00-17:30",
  priceRange: "££",
  areaServed: ["Romford", "London and the surrounding areas", "United Kingdom"],
  description:
    "Aluminium windows, doors, bifolds, curtain walling, shopfronts and partitions fabricated factory-direct in Romford. Trade supply only and full supply & installation for homeowners and construction companies.",
  knowsAbout: [
    "aluminium windows", "aluminium doors", "bifold doors", "curtain walling",
    "aluminium shopfronts", "commercial aluminium doors", "powder coating", "aluminium fabrication",
  ],
};

const WEBSITE_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: SITE.name,
  url: "https://empirealu.uk",
  publisher: { "@id": "https://empirealu.uk/#business" },
};

const ORGANIZATION_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": "https://empirealu.uk/#organization",
  name: "Empire Facade Group Ltd",
  legalName: "Empire Facade Group Ltd",
  alternateName: "Empire Aluminium Windows",
  identifier: { "@type": "PropertyValue", propertyID: "Company number", value: "13655313" },
  url: "https://empirealu.uk",
  logo: SITE.logo,
  telephone: SITE.phone,
  email: SITE.email,
  address: {
    "@type": "PostalAddress",
    streetAddress: `${SITE.address.line1}, ${SITE.address.line2}`,
    addressLocality: SITE.address.town,
    postalCode: SITE.address.postcode,
    addressCountry: "GB",
  },
};

export const SEO = ({ title, description, path = "/", schema, faqs }) => {
  const url = `https://empirealu.uk${path}`;
  const schemas = [ORG_SCHEMA, WEBSITE_SCHEMA, ORGANIZATION_SCHEMA];
  if (schema) schemas.push(...(Array.isArray(schema) ? schema : [schema]));
  if (faqs && faqs.length) {
    schemas.push({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    });
  }
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:image" content={SITE.logo} />
      <meta property="og:locale" content="en_GB" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="geo.region" content="GB-HAV" />
      <meta name="geo.placename" content="Romford" />
      {schemas.map((s, i) => (
        <script key={`${s["@type"]}-${i}`} type="application/ld+json">{JSON.stringify(s)}</script>
      ))}
    </Helmet>
  );
};
